import * as angular from "angular";
import {IController, IQService} from "angular";
import {AccountModel} from "../../angular/models/account.model";

export class DemandBillingAccountSelect implements IController{

  selectedId: any;
  depotIds: string[];
  isRequired: boolean;
  ngPlaceholder: any;
  noUnderline: any;

  onChange: Function;

  private loadLimit: number;
  private billingAccountsRef: any;
  private currentSelectedAccount: any;
  private loaded: boolean;
  private accounts: AccountModel[];
  private selectedAccount: any;
  private searchTerm: any;

  constructor(private $mdSelect, private $log, private $billingAccounts, private $q: IQService) {
  }


  $onInit() {
    this.loadLimit = 50;
    this.billingAccountsRef = this.$billingAccounts();

    this.loaded = false;
    this.accounts = [];
    this.searchTerm = '';

    if (this.selectedId) {
      this.billingAccountsRef.$asyncValues([this.selectedId])
        .then((accounts) => {
          this.accounts = accounts;
          this.selectedAccount = accounts[0];
        })
        .catch((error) => {
          this.$log.error('Failed to get shipper accounts', error);
        });
    } else {
      this.accounts = [];
      this.selectedAccount = undefined;
    }
  };

  $onChanges(changes) {
    if (changes.selectedId && !changes.selectedId.isFirstChange()) {
      this.loaded = false;
      this.$onInit();
    }
  };

  onQueryChange(searchTerm) {
    this.searchTerm = searchTerm
    this.loaded = false;
    this.onOpen();
  }

  onOpen() {

    this.currentSelectedAccount = this.selectedAccount;

    if (!this.loaded) {
      const query = {
        limit: this.loadLimit,
        query: this.searchTerm
      }
      return this.billingAccountsRef.$getAll(query)
        .then((accountIds) => {
          return this.billingAccountsRef.$asyncValues(accountIds);
        })
        .then((accounts) => {
          this.loaded = true;
          this.accounts = accounts;
        })
        .catch((error) => {
          this.$log.error('Fail to $getAll', error);
        });

    } else {
      return this.$q.when();
    }
  }

  onClose() {
    this.searchTerm = '';
    this.selectedAccount = this.currentSelectedAccount;
  }

  cancel() {
    this.$mdSelect.hide();
  }

  reset() {
    this.searchTerm = '';
    this.selectedAccount = undefined
  }

  select() {
    this.currentSelectedAccount = this.selectedAccount;
    this.onChange({billingAccount: this.selectedAccount});
    this.$mdSelect.hide();
  }


}

angular
  .module('bringoz.admin.accounts')
  .component('demandBillingAccountSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      depotIds: '<?',
      isRequired: '<?',
      ngPlaceholder: '@?',
      noUnderline: '@?',
      onChange: '&',
    },
    template: require('./demand-billing-account-select.html').default,
    controller: DemandBillingAccountSelect
  });
